import React from "react";
import ConfirmationPopup from "../ConfirmationPopup/ConfirmationPopup";

interface DeleteConfirmationPopupProps {
    visible: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const DeleteConfirmationPopup: React.FC<DeleteConfirmationPopupProps> = ({
    visible, onConfirm, onCancel,
}) => {
    return (
        <ConfirmationPopup
            visible={visible}
            onCancel={onCancel}
            onConfirm={onConfirm}
            message="Are you sure you want to delete this item? It cannot be undone."
            confirmButtonText="Delete"
            variant="cancel"
        />
    );
};

export default DeleteConfirmationPopup;
